module.exports = __webpack_public_path__ + "assets/img/backgroud.1cfa5024.png";